export default __webpack_public_path__ + "static/media/runner.ae9d97bf.gif";